import React, { useEffect, useRef, forwardRef } from "react"
import styled, { css } from 'styled-components'

const Section = styled.div`
  padding-bottom: 12.0rem;
  ${({ theme: { breakpoints }}) => css`
    @media (min-width: ${breakpoints.md}px) {
      padding-bottom: 20.0rem;
    }
  `}
`

const Intersection = forwardRef(({ children, ...props }, ref) => {

  const domRef = ref ? ref : useRef()

  const { setIsVisible } = props
  useEffect(() => {
    const callback = (entries, object) => {
      if (entries[0].isIntersecting) {
        setIsVisible(true);
        object.unobserve(domRef.current);
      }
    }
    const options = {
      rootMargin: '-120px 0px'
    }
    const observer = new IntersectionObserver(callback, options)
    if (domRef.current) observer.observe(domRef.current);
    return () => observer.disconnect();
  }, [setIsVisible, domRef])

  return (
    <Section ref={ref}>
      {children}
    </Section>
  )
})

export default Intersection